import moment from 'moment';

/**
 * Formatação do relatório semanal — o intervalo da semana e a data do CORTE.
 *
 * ⚠️ Vive fora do componente porque duas superfícies vão precisar: a página e,
 * na W8.c, o card `Fechamento da semana passada` do cockpit. Formatar em dois
 * lugares foi como o "em 0 dia" do convite nasceu.
 *
 * ⚠️ Usa `moment`, que é o que o portal já usa para data curta (`D MMM` no
 * modal de convite) e o que carrega o locale. Escrever um array de meses aqui
 * seria uma segunda fonte para o mesmo fato, e quebraria em inglês.
 */

/**
 * `31 ago – 6 set` a partir de duas datas ISO.
 *
 * 🔴 ESPAÇOS INQUEBRÁVEIS (2026-09-14). O intervalo é uma unidade de leitura, e
 * o navegador o tratava como cinco palavras soltas: na frase do estado vazio ele
 * partia no travessão, deixando `7 set –` no fim de uma linha e `13 set` no
 * começo da outra.
 *
 * ⚠️ O conserto é AQUI e não na largura do container nem na copy: largura só
 * move o ponto da quebra, e copy mais curta volta a quebrar numa tela menor. O
 * NBSP diz o que a coisa É — um bloco — em vez de tentar impedir o sintoma.
 *
 * ⚠️ E vale para todas as superfícies do helper de uma vez (página do relatório
 * e o card do cockpit), em vez de um `white-space: nowrap` por tela.
 */
const NB = '\u00A0';

/**
 * `'current'` · `'previous'` · `null` — a semana relativa a HOJE.
 *
 * 🔴 Pela DATA, nunca pelo número da semana (PO, 19/09). Comparar
 * `weekNumber` exigiria comparar o ano ISO junto, e a semana 1 de 2027 vem
 * depois da 53 de 2026 — a subtração de segundas resolve isso sem saber disso.
 *
 * 🔴 E devolve `null` fora das duas: para a semana 36 o rótulo honesto é o
 * INTERVALO. "Há duas semanas" seria contagem que ninguém pediu, e "semana
 * passada" para qualquer passado é a mentira que este conserto veio corrigir.
 *
 * ⚠️ Rótulo relativo é DÊIXIS: ele descreve o hoje de quem lê. Por isso ele
 * qualifica a NAVEGAÇÃO (onde orientar-se é o trabalho) e nunca substitui o
 * intervalo nas frases que AFIRMAM fato — print e link viajam, a página
 * continua aberta depois da virada, e o absoluto não envelhece.
 */
export function relativeWeekKey(startIso) {
	if (!startIso) return null;
	const start = moment(startIso).startOf('day');
	if (!start.isValid()) return null;
	const thisMonday = moment().startOf('isoWeek');
	const days = thisMonday.diff(start, 'days');
	if (days === 0) return 'current';
	if (days === 7) return 'previous';
	return null;
}

export function formatWeekRange(startIso, endIso) {
	if (!startIso || !endIso) return '';
	const start = moment(startIso);
	const end = moment(endIso);
	if (!start.isValid() || !end.isValid()) return '';
	// ⚠️ `replace` depois do format, e não NBSP dentro da máscara: o moment trata
	//    caracteres desconhecidos como literais, mas depender disso é aposta.
	const fmt = (m) => m.format('D MMM').replace(' ', NB);
	return fmt(start) + NB + '–' + NB + fmt(end);
}

/**
 * `7 set, 03h00` — a hora do corte, vinda do snapshot.
 *
 * 🔴 NUNCA `now()`. É este valor que impede a divergência com o painel (12 aqui,
 * 14 lá) parecer defeito: um é fotografia, o outro é tempo real.
 *
 * ⚠️ A HORA É LIDA DO DADO, não escrita na copy. O corte real é 03h00 e não
 * 06h00 como a redline escreveu — o `mission.engine.fire-hour` já vale 3, e
 * mover a hora moveria a virada das missões junto (PO, 2026-09-08). Cravar
 * "06h00" no texto faria o selo mentir no dia em que a hora mudasse.
 */
export function formatCutAt(iso) {
	if (!iso) return '';
	const m = moment(iso);
	return m.isValid() ? m.format('D MMM, HH[h]mm') : '';
}
